<button type="button" [class]="ButtonClass" (click)="OnClick()" [disabled]="IsDisabled">
    <ng-content></ng-content>
</button>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/buttons/button/button.html